// extracted by mini-css-extract-plugin
export default {"widget":"PaymentMethodWidget_widget__n7O3F"};